import { userService } from "../../user/Service";
import { store } from "./store";
import { userConstants } from "../../user/Constants";
import { getCredentials, clearTokenCookie, setTokenCookie } from "./auth-header";

let loginInProgress = false;

export const handleResponse = async (response) => {
  try {
    const contentType = response.headers.get("content-type");

    if (!response.ok) {
      // If the response is not OK, handle the error
      const errorText = await response.text();
      throw new Error(errorText || "Unknown error occurred");
    }

    // Ensure response is not undefined or empty
    if (!response || !response.json) {
      throw new Error("Invalid response received");
    }

    if (contentType && contentType.includes("application/json")) {
      const json = await response.json();

      if (json && json.status === "tokenExpired") {
        triggerAutoLogin();
      }

      return json;
    }

    // Handle non-JSON responses
    return contentType && contentType.includes("application/json")
      ? await response.json()
      : response;

  } catch (error) {
    return Promise.reject(error.message);
  }
};

export const triggerAutoLogin = () => {
  if (loginInProgress) return;

  const credentials = getCredentials();
  if (!credentials) return;

  loginInProgress = true;
  userService
    .login(credentials.email, credentials.password)
    .then((user) => {
      if (user && user.user && user.status === "OK") {
        setTokenCookie(user.token);
        store.dispatch({ type: userConstants.LOGIN_SUCCESS, user });
      } else {
        clearTokenCookie();
        store.dispatch({ type: userConstants.LOGOUT });
      }
    })
    .catch(() => {
      clearTokenCookie();
      store.dispatch({ type: userConstants.LOGOUT });
    })
    .finally(() => {
      loginInProgress = false;
    });
};

export const handleError = (error) => {
  if (!error) {
    return Promise.reject("An unknown error occurred.");
  }
  // Handle different types of errors
  if (error.response) {
    // API response errors (server-side)
    return Promise.reject(error.response.data?.message || "Server error occurred.");
  } else if (error.request) {
    // Network errors
    return Promise.reject("Network error. Please check your connection.");
  } else {
    // Generic JavaScript errors
    return Promise.reject(error.message || "An error occurred...");
  }
};
